import { Auth0 } from '../react-auth0-spa';
import { RBAC_AUD } from '../config';

export const getToken = async (audience = RBAC_AUD) => {
  // TODO: Implement verify JWT
  try {
    return await Auth0.client.getTokenSilently({ audience });
  } catch (error) {
    if (
      error.error === 'consent_required' ||
      error.error === 'login_required'
    ) {
      // handle consent required with a getTokenWithPopup
      // eslint-disable-next-line no-return-await
      return await Auth0.client.getTokenWithPopup({ audience });
    }
    throw error;
  }
};
